const stats = [
  { value: "600+", label: "部复古作品" },
  { value: "24 万", label: "位阅读读者" },
  { value: "98%", label: "读者好评率" },
  { value: "12 个", label: "主题栏目" },
];

export default function Hero() {
  return (
    <section id="top" className="relative isolate flex min-h-[560px] items-center overflow-hidden bg-foreground-950 md:min-h-[600px]">
      {/* 背景 */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=collage%20of%20overlapping%20vintage%20printed%20comic%20book%20panels%20on%20aged%20cream%20paper%20background%2C%20halftone%20dots%2C%20rust%20red%20amber%20and%20ink%20washes%2C%20retro%201980s%20chinese%20comic%20art%20texture%2C%20warm%20atmospheric%20lighting%2C%20abstract%20editorial%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=hero-collage-01&orientation=landscape"
          alt="纸盒漫画网纸质漫画拼贴背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/60 to-foreground-950/90"></div>
        <div className="halftone absolute inset-0 opacity-[0.06]"></div>
      </div>

      <div className="container-paper w-full py-24 md:py-28">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-background-50/10 px-4 py-1.5 text-xs tracking-[0.18em] text-accent-200 backdrop-blur-sm">
            <i className="ri-award-line text-sm leading-none" aria-hidden="true"></i>
            复古漫画 · 纸质原稿质感
          </span>

          <h1 className="mt-6 font-display text-4xl leading-tight text-background-50 md:text-6xl">
            打开纸盒，翻开一页
            <span className="mt-2 block text-accent-300">有温度的老漫画</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-8 text-background-50/85 md:text-lg">
            纸盒漫画网专注纸质风格阅读体验，还原实体书感与印刷效果。
            泛黄的纸色、细密的网点与细腻的原稿细节，让每一次翻页都更接近真实地捧起一本旧书。
          </p>

          <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
            <a
              href="#featured"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-400 sm:w-auto"
            >
              <i className="ri-book-open-line text-base leading-none" aria-hidden="true"></i>
              开始阅读
            </a>
            <a
              href="#features"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-background-50/40 bg-background-50/5 px-7 py-3.5 text-sm text-background-50 whitespace-nowrap backdrop-blur-sm transition-colors hover:bg-background-50/15 sm:w-auto"
            >
              <i className="ri-sparkling-2-line text-base leading-none" aria-hidden="true"></i>
              了解纸质阅读
            </a>
          </div>

          {/* 数据 */}
          <dl className="mt-14 grid w-full grid-cols-2 gap-px overflow-hidden rounded-xl bg-background-50/10 sm:grid-cols-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="flex flex-col items-center gap-1 bg-foreground-950/40 px-4 py-5 backdrop-blur-sm"
              >
                <dt className="order-2 text-xs text-background-50/70">{s.label}</dt>
                <dd className="order-1 font-display text-2xl text-accent-300">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}